var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['blur-background', _vm.sidebarLeft ? 'sidebar-left': 'sidebar-mobile'],on:{"click":_vm.onClickHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }